import React from "react";

const Error = () => {
  return (
    <div>
      <h1>에러!! 다시 시도해 주시면 감사합니다.</h1>
    </div>
  );
};

export default Error;
